var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"plv-iar-btn pws-vclass-btn--primary",class:( _obj = {}, _obj[_vm.typeClass] = true, _obj[_vm.pwsTypeClass] = true, _obj['is-disabled'] =  _vm.disabled, _obj['plv-iar-btn-default__small'] =  _vm.size === 'small', _obj ),style:(_vm.btnStyle),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }